import type { ReactNode } from "react"
import { useEffect } from "react"
import { Spinner } from "@motleyhand/design"
import { useDispatch, useSelector } from "../store"
import { clearAuth, getLoading, getTokenAvailable } from "../auth/slice"
import { useTokenRefreshMutation } from "../baseApi"
import { getRefreshToken } from "../auth/refreshTokenStorage"

type Props = {
  children: ReactNode
}

export default function AuthWrapper({ children }: Props) {
  const isTokenAvailable = useSelector(getTokenAvailable)
  const isLoading = useSelector(getLoading)
  const [tokenRefresh] = useTokenRefreshMutation()
  const dispatch = useDispatch()

  // Fetch auth token when missing from store
  useEffect(() => {
    if (isTokenAvailable) {
      // Already have an access token
      return
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      dispatch(clearAuth())

      return
    }

    void (async () => {
      try {
        await tokenRefresh(refreshToken).unwrap()

        return
      } catch {
        // Invalid refresh token
        dispatch(clearAuth())
      }
    })()
  }, [isTokenAvailable, dispatch, tokenRefresh])

  if (isLoading) {
    return <Spinner />
  }

  return children
}
